/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_636795ec"]'><div :class='["checkbox-styled-demo"]'><view-desc>圆形选项：{{ checkboxValue }}</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :value="checkboxValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkboxValue", "__mpx_event__", ["value"], undefined]])'>Checkbox</cube-checkbox></div><view-desc>方形选择框：{{ checkboxValue }}</view-desc><div :class='["cube-checkbox-example"]'><cube-checkbox :option="(option)" shape="square" :value="checkboxValue" mpxModelEvent="input" @mpxModel='(e)=>__invoke(e, [["__model","checkboxValue", "__mpx_event__", ["value"], undefined]])'>Styled Checkbox</cube-checkbox></div></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_636795ec"}'>
.cube-checkbox-example
  padding 5px 10px
  background-color #fff
.desc
  margin-top 15px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_636795ec"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_636795ec"}
  /** script content **/
  require("./styled.mpx.js?isComponent&outputPath=components%2Fstyled636795ec%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./styled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fstyled636795ec%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_636795ec"],
    ctorType: "component",
    outputPath: "components/styled636795ec/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'view-desc':getComponent(require("../../components/desc/index.mpx?isComponent&outputPath=components%2Findex590d50a3%2Findex")),'cube-checkbox':getComponent(require("../../../packages/mpx-cube-ui/src/components/checkbox/index.mpx?isComponent&outputPath=components%2Findex04c57aca%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>